import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

const AddEventValidationSchema = () => {
  const { t } = useTranslation()

  return Yup.object({
    name: Yup.string().required(t("addEventPage.nameErrMsg")),
    title: Yup.string().required(t("addEventPage.titleErrMsg")),
    aboutEvent: Yup.string().required(t("addEventPage.aboutEventErrMsg")),
    venue: Yup.string().required(t("addEventPage.venueErrMsg")),
    startDate: Yup.mixed().required(t("addEventPage.startDateErrMsg")),
    endDate: Yup.mixed().required(t("addEventPage.endDateErrMsg")),
    startTime: Yup.string().required(t("addEventPage.startTimeErrMsg")),
    endTime: Yup.string().required(t("addEventPage.endTimeErrMsg")),
  });
};

export default AddEventValidationSchema